<template>
  <div>

    <div v-for="x in fields" :key="x.name" v-show="x.filterable != 'no' && x.visible != false">
      <filterfield :fieldobj="x" @filterdone="$emit('filterdone')"></filterfield>
    </div>

  </div>
</template>

<script>
import { fieldsprocess } from "zxg-table-fieldsprocess";
import filterfield from "./filterbox_filter_field.vue";

export default {
  components: { filterfield },
  mounted() {

  },
  data() {
    return {

    }
  },
  computed: {
    fields() {
      return fieldsprocess(this.$store.state.currentheader, "table",this.$store);
    },

    filter() {
      return this.$store.state.filter;
    }
  },
  methods: {

  }
};
</script>


// WEBPACK FOOTER //
// src/components/presentation/table/filterbox_filter.vue